// Normalized text-selection shape shared across the Copilot document editors. The user's highlighted text
// is the primary signal; the anchors are best-effort and supplementary (SuperDoc exposes portable
// blockId+offset positions).
export interface CopilotDocumentSelection {
  // The selected text. Capped at MAX_SELECTION_CHARS before it leaves the browser.
  text: string;
  // Best-effort start anchor (SuperDoc: SelectionTarget block id + character offset). Undefined when the
  // editor exposes none or the selection start is not a text point (e.g. a node-edge boundary).
  startBlockId?: string;
  startOffset?: number;
  // Best-effort end anchor (SuperDoc: SelectionTarget block id + character offset). Undefined when the
  // editor exposes none or the selection end is not a text point.
  endBlockId?: string;
  endOffset?: number;
}

// Upper bound on selection text sent with a request, so a very large highlight cannot bloat the prompt. The
// backend truncates document content separately; this only guards the pushed selection.
export const MAX_SELECTION_CHARS = 4000;

// Cap selection text to MAX_SELECTION_CHARS.
export function capSelectionText(text: string): string {
  return text.length > MAX_SELECTION_CHARS ? text.slice(0, MAX_SELECTION_CHARS) : text;
}
